import { Navigate, Route, Routes } from 'react-router-dom';

import { getEnv } from '../utilities/env';
import { HomePage } from '../../pages/Home/HomePage';
import { PrivacyPolicyPage } from '../../pages/Home/PrivacyPolicyPage';

export const HOME_BASENAME = getEnv('HOME_APP_BASENAME') ?? '/home';

export const HomeRoutes = (): JSX.Element => (
    <Routes>
        <Route index element={<HomePage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
);
